<template>
  <base-modal :is_loading="is_content_loading">
    <z-form ref="form">
      <z-form-group class="row">
        <div class="col-2">
          {{ $t('shared.component.table.field.name') }}
        </div>
        <div class="col-10">
          <z-form-input :rules="{ required: true, max: 100 }">
            <i-input v-model="form.name" />
          </z-form-input>
        </div>
      </z-form-group>

      <z-form-group class="row mb-2">
        <div class="col-2">
          {{ $t('db.database.field.group') }}
        </div>
        <div class="col-10">
          <z-form-input vid="database_group_id">
            <i-select v-model="form.database_group_id" :filterable="true" :clearable="true">
              <i-option v-for="g in groups" :key="g.id" :value="g.id" :label="g.name" />
            </i-select>
          </z-form-input>
        </div>
      </z-form-group>
    </z-form>
    <i-button
      slot="footer-ok"
      type="success"
      size="large"
      :disabled="is_content_loading && is_button_loading"
      :loading="is_button_loading"
      @click="save"
    >
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import { DataBaseGroupService } from '@db/services/GroupService';
  import defaultsDeep from 'lodash-es/defaultsDeep';
  import pick from 'lodash-es/pick';
  import { DataBaseService } from '@db/services/DataBaseService';
  import { PageServerValidationResponseMixin } from '@shared/mixins/page-server-validation-response';

  export default {
    components: {
      BaseModal
    },
    mixins: [PageServerValidationResponseMixin],

    props: {
      id: {
        type: [Number, String],
        default: undefined
      },

      item: {
        type: Object,
        default: () => ({})
      }
    },

    data: () => ({
      form: {},
      groups: [],
      is_content_loading: false,
      is_button_loading: false,
      initialDatabaseGroupId: undefined
    }),

    watch: {
      item: {
        handler: function (val) {
          this.form = defaultsDeep(pick(val, ['name', 'database_group_id']), {
            name: '',
            database_group_id: null
          });
        },
        immediate: true,
        deep: true
      }
    },

    created() {
      this.is_content_loading = true;
      this.initialDatabaseGroupId = this.form.database_group_id;

      DataBaseGroupService.getSelect()
        .then((res) => (this.groups = res))
        .finally(() => (this.is_content_loading = false));
    },
    methods: {
      save() {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            this.is_button_loading = true;

            let request;
            if (this.id) {
              const updatedForm = { ...this.form };

              if (!!this.initialDatabaseGroupId && this.form.database_group_id === undefined) {
                updatedForm.database_group_id = null;
              } else if (this.initialDatabaseGroupId !== this.form.database_group_id) {
                updatedForm.database_group_id = this.form.database_group_id;
              } else if (this.initialDatabaseGroupId === this.form.database_group_id) {
                updatedForm.database_group_id = undefined;
              }

              request = DataBaseService.editItem(this.id, updatedForm);
            } else {
              request = DataBaseService.createItem(this.form);
            }

            request
              .then((res) => this.$emit('success', res))
              .catch((e) => {
                this.$noty.server_error(e);
                this.check_server_validation(e);
                this.$emit('fail', e);
              })
              .finally(() => (this.is_button_loading = false));
          }
        });
      }
    }
  };
</script>
